import { c as _c } from "react/compiler-runtime";
interface OptimismIconProps {
  className?: string;
}
export function OptimismIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M0 100C0 44.7715 44.7715 0 100 0C155.228 0 200 44.7715 200 100C200 155.228 155.228 200 100 200C44.7715 200 0 155.228 0 100Z" fill="white" />;
    t2 = <path d="M100 0C44.7715 0 0 44.7715 0 100C0 155.228 44.7715 200 100 200C155.228 200 200 155.228 200 100C200 44.7715 155.228 0 100 0ZM100 150.916V192.674C60.3487 192.674 28.2051 160.53 28.2051 120.879C28.2051 81.228 60.3487 49.0843 100 49.0843V7.32601C139.651 7.32601 171.795 39.4696 171.795 79.1209C171.795 118.772 139.651 150.916 100 150.916ZM134.432 99.6797V100.32C119.255 107.884 107.884 119.255 100.32 134.432H99.6801C92.1159 119.255 80.7449 107.884 65.5678 100.32V99.6797C80.7449 92.1156 92.1159 80.7448 99.6801 65.5678H100.32C107.884 80.7448 119.255 92.1156 134.432 99.6797Z" fill="#FF0420" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}